import styles from "./day.module.css";
import Acardeon from "./acardeon/Acardeon";
import AcardeonMian from "./acardeon/AcardeonMian";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select/creatable";
import { translateToReactSelect } from "admin-panel/create-tours/helperFunctions";
import AcarderonEghamat from "./acardeon/acardeonEghamat";
import { MdFreeBreakfast } from "react-icons/md";
import { MdDinnerDining } from "react-icons/md";
import { BiBusSchool } from "react-icons/bi";
import { MdOutlineNoFood } from "react-icons/md";
import { BsFillMoonFill } from "react-icons/bs";
import { FaHotel } from "react-icons/fa";
import { FaCloudSun } from "react-icons/fa";
import { MdLunchDining } from "react-icons/md";
import AcardeonTransfer from "./acardeon/AcardeonTransfer";
import AcardeonGashtha from "./acardeon/AcardeonGashtha";
import { BsSunFill } from "react-icons/bs";
import { useMeals, useMealsAction } from "../../../Context/MealsProvider";
import { FaEye } from "react-icons/fa";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

const MealList = ({ dayIndex }) => {
  const meals = useMeals();
  const dispatch = useMealsAction();
  const animatedComponents = makeAnimated();
  const optionDasteBandi = [
    { label: " قایق", value: "ghayegh" },
    { label: " نیسان", value: "neysan" },
    { label: " آفرود", value: "offroad" },
    { label: " تراکتور", value: "tractor" },
    { label: " موتور سه چرخ", value: "secharkh" },
  ];

  const statusChanger = (id) => {
    dispatch({
      type: "changeHandlerPublic",
      day: dayIndex,
      mealId: id,
    });
  };

  return (
    <div className={styles.containerMeal}>
      {meals[dayIndex].map((meal, index) => {
        return (
          meal.status &&
          (meal.id == 8 ? (
            <div className={styles.mealRow}>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <p className={styles.titlepText}>
                    <BiBusSchool className={styles.gashtSob} />
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={addCommas(meals[dayIndex][index].price)}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandler",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                  <FaEye
                    className={`${styles.mealEye} ${
                      meals[dayIndex][8].isPublic && styles.black
                    }`}
                    onClick={() => statusChanger(8)}
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <p className={`${styles.titlepText} ${styles.titlemargin}`}>
                    نوع
                  </p>
                  <CreatableSelect
                    value={translateToReactSelect(
                      meals[dayIndex][index].noe,
                      false
                    )}
                    onChange={(value) =>
                      dispatch({
                        day: dayIndex,
                        type: "changeHandlerNoe",
                        day: dayIndex,
                        id: index,
                        value: translateToReactSelect([value], true),
                      })
                    }
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    className={styles.inputBoxSelect}
                    options={optionDasteBandi}
                  />
                  <div className={styles.priceOtherBox}>
                    <div className={styles.acaardeon}>
                      <Acardeon index={index} dayIndex={dayIndex} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : meal.id == 6 ? (
            <div className={styles.mealRow}>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <p className={styles.titlepText}>
                    <FaHotel className={styles.gashtSob} />
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={addCommas(meals[dayIndex][index].price)}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandler",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                  <FaEye
                    className={`${styles.mealEye} ${
                      meals[dayIndex][index].isPublic && styles.black
                    }`}
                    onClick={() => statusChanger(6)}
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <p className={`${styles.titlepText} ${styles.titlemargin}`}>
                    نوع
                  </p>
                  <select
                    class="form-select form-select-sm"
                    aria-label=".form-select-sm example"
                    className={styles.inputBoxs}
                    value={meals[dayIndex][index].noeEghamat}
                    onChange={(e) =>
                      dispatch({
                        day: dayIndex,
                        type: "changeHandlerNoeEghamat",
                        id: index,
                        event: e,
                      })
                    }
                  >
                    <option selected className={styles.selected}></option>
                    <option value="1">هتل</option>
                    <option value="2">هتل آپارتمان</option>
                    <option value="3">اقامتگاه بوم گردی</option>
                    <option value="4">خانه محلی</option>
                    <option value="5">کمپ</option>
                  </select>
                  <div className={styles.priceOtherBox}>
                    <div className={styles.acaardeon}>
                      <AcarderonEghamat index={index} dayIndex={dayIndex} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : meal.id == 0 ? (
            <div className={styles.mealRow}>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <p className={styles.titlepText}>
                    <BsSunFill className={styles.gashtSob} />
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={addCommas(meals[dayIndex][index].price)}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandler",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                  <FaEye
                    className={`${styles.mealEye} ${
                      meals[dayIndex][index].isPublic && styles.black
                    }`}
                    onClick={() => statusChanger(0)}
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <p className={`${styles.titlepText} ${styles.titlemargin}`}>
                    عنوان
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={meals[dayIndex][index].onvan}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandlerOnvan",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                  <div className={styles.priceOtherBox}>
                    <div className={styles.acaardeon}>
                      <AcardeonGashtha index={index} dayIndex={dayIndex} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : meal.id == 4 ? (
            <div className={styles.mealRow}>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <p className={styles.titlepText}>
                    <FaCloudSun className={styles.gashtSob} />
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={addCommas(meals[dayIndex][index].price)}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandler",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                  <FaEye
                    className={`${styles.mealEye} ${
                      meals[dayIndex][index].isPublic && styles.black
                    }`}
                    onClick={() => statusChanger(4)}
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <p className={`${styles.titlepText} ${styles.titlemargin}`}>
                    عنوان
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={meals[dayIndex][index].onvan}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandlerOnvan",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                  <div className={styles.priceOtherBox}>
                    <div className={styles.acaardeon}>
                      <AcardeonGashtha index={index} dayIndex={dayIndex} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : meal.id == 7 ? (
            <div className={styles.mealRow}>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <p className={styles.titlepText}>
                    <BsFillMoonFill className={styles.gashtSob} />
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={addCommas(meals[dayIndex][index].price)}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandler",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                  <FaEye
                    className={`${styles.mealEye} ${
                      meals[dayIndex][index].isPublic && styles.black
                    }`}
                    onClick={() => statusChanger(7)}
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <p className={`${styles.titlepText} ${styles.titlemargin}`}>
                    عنوان
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={meals[dayIndex][index].onvan}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandlerOnvan",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                  <div className={styles.priceOtherBox}>
                    <div className={styles.acaardeon}>
                      <AcardeonGashtha index={index} dayIndex={dayIndex} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : meal.id == 3 ? (
            <div className={styles.mealRow}>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <p className={styles.titlepText}>
                    <MdOutlineNoFood className={styles.gashtSob} />
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={addCommas(meals[dayIndex][index].price)}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandler",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                  <FaEye
                    className={`${styles.mealEye} ${
                      meals[dayIndex][index].isPublic && styles.black
                    }`}
                    onClick={() => statusChanger(3)}
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <p className={`${styles.titlepText} ${styles.titlemargin}`}>
                    عنوان
                  </p>
                  <input
                    type="text"
                    className={`${styles.inputBoxsPadding} ${styles.inputBoxs}`}
                    value={meals[dayIndex][index].onvan}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandlerOnvan",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          ) : meal.id == 5 ? (
            <div className={styles.mealRow}>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <p className={styles.titlepText}>
                    <MdDinnerDining className={styles.gashtSob} />
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={addCommas(meals[dayIndex][index].price)}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandler",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />

                  <FaEye
                    className={`${styles.mealEye} ${
                      meals[dayIndex][index].isPublic && styles.black
                    }`}
                    onClick={() => statusChanger(5)}
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <p className={`${styles.titlepText} ${styles.titlemargin}`}>
                    عنوان
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={meals[dayIndex][index].foodName}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandlerFood",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                  <div className={styles.priceOtherBox}>
                    <div className={styles.acaardeon}>
                      <AcardeonTransfer index={index} dayIndex={dayIndex} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : meal.id == 1 ? (
            <div className={styles.mealRow}>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <p className={styles.titlepText}>
                    <MdFreeBreakfast className={styles.gashtSob} />
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={addCommas(meals[dayIndex][index].price)}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandler",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />

                  <FaEye
                    className={`${styles.mealEye} ${
                      meals[dayIndex][index].isPublic && styles.black
                    }`}
                    onClick={() => statusChanger(1)}
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <p className={`${styles.titlepText} ${styles.titlemargin}`}>
                    عنوان
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={meals[dayIndex][index].foodName}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandlerFood",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                  <div className={styles.priceOtherBox}>
                    <div className={styles.acaardeon}>
                      <AcardeonTransfer index={index} dayIndex={dayIndex} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.mealRow}>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <p className={styles.titlepText}>
                    <MdLunchDining className={styles.gashtSob} />
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={addCommas(meals[dayIndex][index].price)}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandler",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />

                  <FaEye
                    className={`${styles.mealEye} ${
                      meals[dayIndex][index].isPublic && styles.black
                    }`}
                    onClick={() => statusChanger(2)}
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <p className={`${styles.titlepText} ${styles.titlemargin}`}>
                    عنوان
                  </p>
                  <input
                    type="text"
                    className={styles.inputBoxs}
                    value={meals[dayIndex][index].foodName}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandlerFood",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                  <div className={styles.priceOtherBox}>
                    <div className={styles.acaardeon}>
                      <AcardeonTransfer index={index} dayIndex={dayIndex} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        );
      })}
    </div>
  );
};

export default MealList;
